<!--
    @公共文件筛选
-->
<template>
	<div class="common_screen">
		<!-- 待办事项清单 -->
		<div class="screen_con" v-if="type==1">
			<div class="first_row item">
				<div class="screen_type">
					<span class="screen_title">待办状态：</span>
					<div>
						<span class="screen_btn" @click="dealStatusHandle(item.value)"
							:class="item.value==dealForm.historyid?'check':null"
							v-for="(item,i) in dealStatusList" :key="i"
						>{{item.name}}</span>
					</div>
				</div>
				<el-button type="text" @click="openClick" v-show="!isOpen">展开</el-button>
				<el-button type="text" @click="openClick" v-show="isOpen">关闭</el-button>
			</div>
			<div class="is_open" v-show="isOpen">
				<div class="item">
					<div>
						<span class="screen_title">处理部门：</span>
						<a-select v-model="dealForm.assigneeids" @change="dealAssigneeidHandle" style="width:400px;" placeholder="请选择" mode="multiple" option-label-prop="label">
							<a-select-option v-for="item in departmentlist" :key="item.id"
								:label="item.name" :value="item.id">{{item.name}}
							</a-select-option>
						</a-select>
					</div>
				</div>
				<div class="item">
					<div class="two_row">
						<span class="screen_title">提交时间：</span>
						<el-date-picker type="daterange" @change="dealCreatedDateHandle" v-model="dealCreateDate" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
					</div>
					<div class="two_row">
						<span class="screen_title">处理时间：</span>
						<el-date-picker type="daterange" @change="dealProcessDateHandle" v-model="dealProcessDate" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
					</div>
				</div>
			</div>
		</div>
		<!-- 今日开标项目 -->
		<div class="screen_con" v-if="type==2">
			<div class="first_row item" v-if="navClick=='GC'||navClick=='CG'">
				<div class="screen_type">
					<span class="screen_title">项目类型：</span>
					<div>
						<span class="screen_btn" @click="openTypeHandle(item.value)" :class="item.value==openForm.openType?'check':null"
							v-for="(item,i) in projectTypeList" :key="i"
						>{{item.name}}</span>
					</div>
				</div>
				<!-- <el-button type="text" @click="openClick" v-show="!isOpen">展开</el-button>
				<el-button type="text" @click="openClick" v-show="isOpen">关闭</el-button> -->
			</div>
			<div class="is_open" v-if="isOpen||navClick=='GT'||navClick=='CQ'">
				<!-- <div class="item" v-show="navClick=='GC'||navClick=='CG'">
					<div class="two_row">
						<span class="screen_title">开标时间：</span>
						<el-date-picker type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
					</div>
				</div> -->
				<div class="item" v-if="navClick=='GT'||navClick=='CQ'">
					<div class="two_row">
						<span class="screen_title">竞价时间：</span>
						<el-date-picker type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
					</div>
				</div>
			</div>
		</div>
		<!-- 项目跟踪 -->
		<div class="screen_con" v-if="type==3">
			<div class="first_row item">
				<div class="screen_type">
					<span class="screen_title">项目状态：</span>
					<div v-if="navClick=='GC'||navClick=='CG'">
						
						<span class="screen_btn" @click="projectStatusHandle(item.value)" :class="item.value==projectForm.projectStatus?'check':null"
							v-for="(item,i) in projectStatusList" :key="i"
						>{{item.name}}</span>
					</div>
					<div v-if="navClick=='CQ'||navClick=='GT'">
						<span class="screen_btn" @click="projectStatusHandle(item.value)" :class="item.value==projectForm.projectStatus?'check':null"
							v-for="(item,i) in projectStatusList1" :key="i"
						>{{item.name}}</span>
					</div>

				</div>
				<!-- <el-button type="text" @click="openClick" v-show="!isOpen">展开</el-button>
				<el-button type="text" @click="openClick" v-show="isOpen">关闭</el-button> -->
			</div>
			<div class="is_open" v-show="true">
				<div class="item" v-if="navClick=='GC'||navClick=='CG'">
					<div class="screen_type">
						<span class="screen_title">项目类型：</span>
						<div>
							<span class="screen_btn" @click="projectTypeHandle(item.value)" :class="item.value==projectForm.projectType?'check':null"
								v-for="(item,i) in projectTypeList" :key="i"
							>{{item.name}}</span>
						</div>
					</div>
				</div>
				<!-- v-if="navClick=='GC'||navClick=='CG'" -->
				<div class="item items" v-if="true">
					<div class="three_row">
						<span class="screen_title">开标时间：</span>
						<el-date-picker v-model="projecBidOpenTime"  @change="projecBidOpenTimeHandle" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
					</div>
					<div class="three_row">
						<span class="screen_title">中标结果公告时间：</span>
						<el-date-picker v-model="projecBuyprojectresultnoticeTime" @change="projecBuyprojectresultnoticeTimeHandle" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
					</div>
				</div>
                <div style="display:flex;justify-content: space-between" >
                    <div class="four_row" style="display:flex;align-items:center;width:100%;">
						<div><span class="screen_title" >数据所属部门：</span></div>
                        <select-depart-tree
                            ref="selectDepartTreeRef"
                            :type="'2'"
                            :modelValue.sync="projectForm.superviseDeptCodeList"
                            :isMultiple="true"
                            @handleDeptType="(val)=>changeDept(val,'5')"
                            :widthValue="765"
                            >
                        </select-depart-tree>
					</div>
					<div class="searchBtn">
						<el-button @click="resetData" size="small">重置</el-button>
					</div>
                </div>
				<div class="item" v-if="navClick=='CQ'||navClick=='GT'">
					<div class="two_row">
						<span class="screen_title">限时竞价时间：</span>
						<el-date-picker @change="projecBidOpenTimeHandle"  end-placeholder="结束日期" range-separator="至" start-placeholder="开始日期" type="daterange" v-model="projecEntryTime" value-format="yyyy-MM-dd"></el-date-picker>
					</div>
					<div class="two_row">
						<span class="screen_title">中标结果公告时间：</span>
						<el-date-picker v-model="projecBuyprojectresultnoticeTime1" @change="projecBuyprojectresultnoticeTimeHandle" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
					</div>
				</div>
			</div>
			
		</div>

		<!-- 流程失效监管 -->
		<div class="screen_con" v-if="type==4">
			<div class="first_row item">
				<div class="screen_type">
					<span class="screen_title">项目状态：</span>
					<div v-if="navClick=='GC'||navClick=='CG'">
						
						<span class="screen_btn" @click="projectStatusHandle(item.value)" :class="item.value==projectForm.projectStatus?'check':null"
							v-for="(item,i) in projectStatusList" :key="i"
						>{{item.name}}</span>
					</div>
					<div v-if="navClick=='CQ'||navClick=='GT'">
						<span class="screen_btn" @click="projectStatusHandle(item.value)" :class="item.value==projectForm.projectStatus?'check':null"
							v-for="(item,i) in projectStatusList1" :key="i"
						>{{item.name}}</span>
					</div>
				</div>
				<!-- <el-button type="text" @click="openClick" v-show="!isOpen">展开</el-button>
				<el-button type="text" @click="openClick" v-show="isOpen">关闭</el-button> -->
			</div>
			<div class="is_open" v-show="true">
				<div class="item" v-if="navClick=='GC'||navClick=='CG'">
					<div class="screen_type">
						<span class="screen_title">项目类型：</span>
						<div>
							<span class="screen_btn" @click="projectTypeHandle(item.value)" :class="item.value==projectForm.projectType?'check':null"
								v-for="(item,i) in projectTypeList" :key="i"
							>{{item.name}}</span>
						</div>
					</div>
				</div>
				<!-- v-if="navClick=='GC'||navClick=='CG'" -->
				<div class="item" v-if="true">
					<div class="two_row">
						<span class="screen_title">项目进场时间：</span>
						<el-date-picker @change="projecEntryTimeHandle"  end-placeholder="结束日期" range-separator="至" start-placeholder="开始日期" type="daterange" v-model="projecEntryTime" value-format="yyyy-MM-dd"></el-date-picker>
					</div>
					<div class="two_row">
						<span class="screen_title">开标时间：</span>
						<el-date-picker @change="projecBidOpenTimeHandle"  end-placeholder="结束日期" range-separator="至" start-placeholder="开始日期" type="daterange" v-model="projecBidOpenTime" value-format="yyyy-MM-dd"></el-date-picker>
					</div>


				</div>
			    <div class="item">
					<div class="two_row">
						<span class="screen_title">中标结果公告发布时间：</span>
						<el-date-picker @change="projecBuyprojectresultnoticeTimeHandle" end-placeholder="结束日期" range-separator="至" start-placeholder="开始日期" type="daterange" v-model="projecBuyprojectresultnoticeTime" value-format="yyyy-MM-dd"></el-date-picker>
					</div>

				</div>
               <div style="display:flex;justify-content: space-between;">
                <div class="four_row" style="display:flex;align-items:center;width:100%;">
						<div><span class="screen_title" style="margin-right:20px;">数据所属部门：</span></div>
                        <select-depart-tree
                            ref="selectDepartTreeRef"
                            :type="'2'"
                            :modelValue.sync="projectForm.superviseDeptCodeList"
                            :isMultiple="true"
                            @handleDeptType="(val)=>changeDept(val,'5')"
                            :widthValue="765"
                            >
                        </select-depart-tree>

					</div>
					<div class="searchBtn">
						<el-button @click="resetFlowEfficiencyData">重置</el-button>
					   </div>
               </div>
			</div>
		</div>


		<!-- 招标计划监管 -->
		<div class="screen_con" v-if="type==5">
			<div class="first_row item">
				<div class="screen_type">
					<span class="screen_title">项目状态：</span>
					<div>
						<span class="screen_btn" @click="projectStatusHandle(item.value)" :class="item.value==projectForm.projectStatus?'check':null"
							  v-for="(item,i) in projectReleaseStatusList" :key="i"
						>{{item.name}}</span>
					</div>
				</div>
			</div>
			<div class="is_open">
				<div class="item items" v-if="false">
					<div class="three_row">
						<span class="screen_title">预计招标时间：</span>
						<el-date-picker v-model="projecBidOpenTime"  @change="projecBidOpenTimeHandle" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
					</div>
				</div>
				<div style="display:flex;justify-content: space-between" v-if="false">
					<div class="four_row" style="display:flex;align-items:center;width:100%;padding-bottom: 8px;">
						<div><span class="screen_title" >数据所属部门：</span></div>
						<select-depart-tree
								ref="selectDepartTreeRef"
								:type="'2'"
								:modelValue.sync="projectForm.superviseDeptCodeList"
								:isMultiple="true"
								@handleDeptType="(val)=>changeDept(val,'5')"
								:widthValue="765"
						>
						</select-depart-tree>
					</div>
				</div>
				<div class="item items">
					<div class="screen_type">
						<span class="screen_title">所属地区：</span>
						<div>
							<span class="screen_btn" @click="regionCodeHandle(item.id)"
								  :class="item.id==projectForm.regionCode?'check':null"
								  v-for="(item,i) in userRegionCodeList" :key="i"
							>{{item.name}}</span>
						</div>
					</div>
					<div class="searchBtn">
						<el-button @click="resetData" size="small">重置</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import selectDepartTree from "@/views/modules/components/selectDepartTree"
export default {
	props:{
		// 头类型 1待办事项清单 2今日开标项目 3项目跟踪 4流程时效可视化监管
		type:{
			type:Number,
			default:1
		},
		// 菜单点击的值 今日开标项目的完成
		navClick:{
			type:String,
			default:''
		},
		// 处理部门-待办事项清单
		departmentlist:{
			type:Array,
			default:function(){
				return [];
			}
		},
		// 项目类型
		projectTypeList:{
			type:Array,
			default:function(){
				return [];
			}
		},
		// 项目计划发布状态
		projectReleaseStatusList:{
			type:Array,
			default:function(){
				return [];
			}
		},
		// 数据所属地区
		regionTreeList:{
			type:Array,
			default:function(){
				return [];
			}
		},
	},
    components:{
        selectDepartTree
    },
	data(){
		return {
			// 是否展开
			isOpen:false,
			value:[],
			userRegionCodeList:[],
			dealStatusList:[
				{name:'全部',value:''},
				{name:'待处理',value:'-1'},
				{name:'已完成',value:'0'}
			],
			// 项目跟踪-工程建设和政府采购
			projectStatusList:[
				{name:'全部',value:''},
				{name:'未开标',value:'1'},
				{name:'已开标（未完结）',value:'2'},
				{name:'已正常完结',value:'3'},
				{name:'招标异常',value:'4'},
			],
			// 项目跟踪-国有产权和国土交易
			projectStatusList1:[
				{name:'全部',value:''},
				{name:'待竞价',value:'1'},
				{name:'自由竞价中',value:'2'},
				{name:'限时竞价中',value:'3'},
				{name:'已完结',value:'4'},
				{name:'招标异常',value:'5'}
			],
			// 待办事项清单表单
			dealForm:{
				historyid:'',
				createDateStart:'',
				createDateEnd:'',
				processDateStart:'',
				processDateEnd:'',
				assigneeids:[]
			},
			dealCreateDate:null,//提交时间
			dealProcessDate:null,//处理时间
			// 今日开标项目表单
			openForm:{
				openType:''
			},
			// 项目跟踪表单
			projectForm:{
				regionCode:'',
				projectStatus:'',
				projectType:'',
				projecEntryTimeStart:'',
				projecEntryTimeEnd:'',
				bidOpenTimeStart:'',
				bidOpenTimeEnd:'',
				buyprojectresultnoticeTimeStart:'',
				buyprojectresultnoticeTimeEnd:'',
                superviseDeptCodeList:[],// 数据所属部门
			},
			projecBidOpenTime:null,//开标时间
			projecBuyprojectresultnoticeTime:null,//中标结果时间
			projecEntryTime:null,//限时竞价时间
			projecBuyprojectresultnoticeTime1:null,//中标结果公告时间
		}
	},
	watch:{
		regionTreeList:{
			immediate: true,
			handler:function(val){
				if(val && val.length){
					let userRegionCodeList = JSON.parse(JSON.stringify(val));
					userRegionCodeList.unshift({
						name:"全部",
						id:''
					})
					this.userRegionCodeList=userRegionCodeList;
				}
			},
			deep:true
		},
		// 监视菜单值，如果变化，对应的筛选状态清空
		navClick(newValue,oldValue){
			if(newValue!=oldValue){
				if(this.type==2){
					this.openForm.openType="";
				}
				if(this.type==3){
					this.projectForm={
						projectStatus:'',
						projectStatus:'',
						projectType:'',
						bidOpenTimeStart:'',
						bidOpenTimeEnd:'',
						buyprojectresultnoticeTimeStart:'',
						buyprojectresultnoticeTimeEnd:''
					}
				}
				
			}
		}
	},
	methods:{
		// 展开按钮的点击
		openClick(){
			this.isOpen=!this.isOpen;
		},
		// 待办事项清单-待办状态点击
		dealStatusHandle(value){
			if(this.dealForm.historyid==value){
				this.dealForm.historyid='';
			}else{
				this.dealForm.historyid=value;
			}
			this.$emit('dealemit',this.dealForm);
		},
		// 待办事项清单-处理部门change
		dealAssigneeidHandle(value){
			this.$emit('dealemit',this.dealForm);
		},
		// 待办事项清单-提交时间change
		dealCreatedDateHandle(value){
			if (value) {
				this.dealForm.createDateStart=value[0]||'';
				this.dealForm.createDateEnd=value[1]||'';
			}else{
				this.dealForm.createDateStart='';
				this.dealForm.createDateEnd='';
			}
			this.$emit('dealemit',this.dealForm);
		},
		// 待办事项清单-处理时间change
		dealProcessDateHandle(value){
			if (value) {
				this.dealForm.processDateStart=value[0]||'';
				this.dealForm.processDateEnd=value[1]||'';
			}else{
				this.dealForm.processDateStart='';
				this.dealForm.processDateEnd='';
			}
			this.$emit('dealemit',this.dealForm);
		},
		// 今日开标项目-项目类型
		openTypeHandle(value){
			if(this.openForm.openType==value){
				this.openForm.openType='';
			}else{
				this.openForm.openType=value;
			}
			this.$emit('openemit',this.openForm)
		},
		regionCodeHandle(value){
			if(this.projectForm.regionCode==value){
				this.projectForm.regionCode='';
			}else{
				this.projectForm.regionCode=value;
			}
			this.$emit('projectemit',this.projectForm)
		},
		// 项目跟踪-项目状态
		projectStatusHandle(value){
			if(this.projectForm.projectStatus==value){
				this.projectForm.projectStatus='';
			}else{
				this.projectForm.projectStatus=value;
			}
			this.$emit('projectemit',this.projectForm)
		},
		// 项目跟踪-项目类型
		projectTypeHandle(value){
			if(this.projectForm.projectType==value){
				this.projectForm.projectType='';
			}else{
				this.projectForm.projectType=value;
			}
			this.$emit('projectemit',this.projectForm)
		},
		// 进场时间-开标时间change
		projecEntryTimeHandle(value){
			if (value) {
				this.projectForm.projecEntryTimeStart=value[0]||'';
				this.projectForm.projecEntryTimeEnd=value[1]||'';
			}else{
				this.projectForm.projecEntryTimeStart='';
				this.projectForm.projecEntryTimeEnd='';
			}
			this.$emit('projectemit',this.projectForm);
		},
		// 项目跟踪-开标时间change
		projecBidOpenTimeHandle(value){
			if (value) {
				this.projectForm.bidOpenTimeStart=value[0]||'';
				this.projectForm.bidOpenTimeEnd=value[1]||'';
			}else{
				this.projectForm.bidOpenTimeStart='';
				this.projectForm.bidOpenTimeEnd='';
			}
			this.$emit('projectemit',this.projectForm);
		},
        changeDept(val,flag){
             // falg==5 表示多选
             this.projectForm.superviseDeptCodeList=[]
            val.forEach((element)=>{
            if( element.type!=="region"){
                this.projectForm.superviseDeptCodeList.push(element.code)
            }
        })
        this.$emit('projectemit',this.projectForm);
        },
		resetData(){//重置
			this.projectForm.projectStatus='';
			this.projectForm.projectType='';
			this.projectForm.regionCode='';

			this.projecBidOpenTime=''
			this.projectForm.bidOpenTimeStart='';
			this.projectForm.bidOpenTimeEnd='';

			this.projecBuyprojectresultnoticeTime="";
			this.projectForm.buyprojectresultnoticeTimeStart='';
			this.projectForm.buyprojectresultnoticeTimeEnd='';

            // 重置数据所属部门
            this.projectForm.superviseDeptCodeList=this.$store.state.dataDictionary.uerdefultOptionCode
             // 重置默认所属数据
            if( this.$refs.selectDepartTreeRef){
                this.$refs.selectDepartTreeRef.getUserTreeOption()
            }
			this.$emit('projectemit',this.projectForm);
			this.$bus.$emit('changeSearch','')

		},
		resetFlowEfficiencyData(){//重置
			this.projectForm.projectStatus='';
			this.projectForm.projectType='';

			this.projecBidOpenTime=''
			this.projectForm.bidOpenTimeStart='';
			this.projectForm.bidOpenTimeEnd='';


			this.projecBuyprojectresultnoticeTime="";
			this.projectForm.buyprojectresultnoticeTimeStart='';
			this.projectForm.buyprojectresultnoticeTimeEnd='';

			this.projecEntryTime="";
			this.projectForm.projecEntryTimeStart='';
			this.projectForm.projecEntryTimeEnd='';
            // 重置数据所属部门
            this.projectForm.superviseDeptCodeList=this.$store.state.dataDictionary.uerdefultOptionCode
             // 重置默认所属数据
            if( this.$refs.selectDepartTreeRef){
                this.$refs.selectDepartTreeRef.getUserTreeOption()
            }
			this.$emit('projectemit',this.projectForm);
			this.$bus.$emit('changeSearch','')

		},
		// 项目跟踪-中标结果公告时间change
		projecBuyprojectresultnoticeTimeHandle(value){
			if (value) {
				this.projectForm.buyprojectresultnoticeTimeStart=value[0]||'';
				this.projectForm.buyprojectresultnoticeTimeEnd=value[1]||'';
			}else{
				this.projectForm.buyprojectresultnoticeTimeStart='';
				this.projectForm.buyprojectresultnoticeTimeEnd='';
			}
			this.$emit('projectemit',this.projectForm);
		},
	}
}
</script>

<style lang="scss" scoped>
.common_screen{
	>.screen_con{
        .screen_title{
				margin-right: 20px;
                display: inline-block;
                width:130px;
                text-align: end;
			}
		.item{
			// height: 60px;
			padding: 5px 0;
			display: flex;
			justify-content: space-between;
			align-items: center;
			// border-bottom: 1px dashed #ebeef5;
			
			.two_row{
				width: 50%;
			}
			.three_row{
				width: 440px;
			}
			.searchBtn{
				margin-left: auto;
				.el-button--medium{
					padding: 8px 20px;
				}
			}
			.screen_type{
				display: flex;
				align-items: center;
				span{
					white-space: nowrap;
				}
				.screen_title{
					margin-right: 20px;
					line-height: 36px;
				}
				>div{
					display: flex;
					flex-wrap: wrap;
				}
				.screen_btn{
					cursor: pointer;
					padding: 7px 15px;
					margin-right: 10px;
					border-radius: 5px;
				}
				.check{
					background: #1890FF;
					color: #ffffff;
				}
			}
		}
		.items{
			justify-content: start;
		}
	}
}
</style>
